<template>
    <v-container fluid grid-list-md class="d-none d-md-flex">
        <v-layout row wrap>
            <v-col cols="12">
                <h3>Internal Notes</h3>
            </v-col>

            <v-col cols="12">
                <textarea v-model="reservation.internal_notes"></textarea>
                <v-btn v-on:click="saveNotes()"><v-icon>save</v-icon> Update Notes</v-btn>
            </v-col>
        </v-layout>
    </v-container>
</template>

<script>
    /**
     * A Vue component dedicated to letting the user manage a reservation's
     * internal notes for staff reference by the ID specified
     *
     * Props:
     *     int 'reservationkey' - The ID of the reservation to display
     */
    import axios from 'axios';
    export default {
        name: 'hotel-reservation-notes',
        props: ['reservationkey'],
        data () {
            return {
                reservation: {}
            }
        },

        methods: {
            loadReservation(){
                axios.get('/api/reservations/id/' + this.reservationkey)
                .then(function(response){
                    this.reservation = response.data.reservation;

                }.bind(this));
            },

            saveNotes(){
                axios.post('/api/reservations/' + this.reservationkey + '/internal-notes', {'internalNotes': this.reservation.internal_notes})
                .then(function(response){
                    if (response.data.success){
                        alert("Saved");
                        this.loadReservation();
                    }
                    else {
                        alert("An error occurred; Notes could not be updated");
                    }
                }.bind(this));
            }
        },

        /**
         * Once mounted this component needs to load the reservation specified
         */
        mounted() {
            this.loadReservation();
        },

        computed: {}
    }
</script>

<style scoped>
textarea {
    border: solid 1px lightgray;
}
</style>
